import React from 'react'
import AddressBlock from "./address-block";

export default function MapUILocationTile({ borderClass, children, name, address, city, state_code, zipcode, lat, lng}) {
  function handleClick(e) {
    e.preventDefault();
  }

  return (
    <div className={`mt-3 overflow-hidden rounded-sm bg-white shadow ${borderClass}`} onClick={handleClick}>
      <div className="px-2 py-3 sm:p-3">
        <h3 className='font-bold'>{name}</h3>
        <AddressBlock
          address={address}
          city={city}
          state_code={state_code}
          zip={zipcode}
        />
        { lat && lng && (
          <div className='mt-1'>
            {lat}, {lng}
          </div>
        )}
        { children }
      </div>
    </div>
  )
}
